//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    descTxt: {
      type:String,
    },
    min: {
      type:Boolean,
      default: false
    },
  },
  data() {
    return {
      isMin: this.min
    }
  },
  created () {
    ;
  },
}



// WEBPACK FOOTER //
// ./src/components/formulaComponent/formulaDescScore.vue